namespace RioERP.Web.Enums {
    export enum EnquiryMode {
        Website = 1,
        WhatsApp = 2,
        OutboundCall = 3,
        Other = 4
    }
    Serenity.Decorators.registerEnumType(EnquiryMode, 'RioERP.Web.Enums.EnquiryMode');
}
